import SurveySelect from './SurveySelect'

export default SurveySelect
